import { mq, Skeleton as _Skeleton } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivFlexContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

export const DivHeaderCarouselSkeleton = styled(_Skeleton)`
  box-sizing: content-box;
  width: 60%;
  padding: 0 8px;
  max-width: 760px;
  flex-shrink: 0;
  min-width: calc(600px - 64px);
  ${mq.sp} {
    max-width: calc(600px - 64px);
    min-width: auto;
    padding: 0 4px;
    width: 100%;
  }
  :before {
    content: "";
    display: block;
    padding-top: 43.75%;
  }
`;
